import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireSrc } from "/home/runner/work/strapi/strapi/packages/plugins/users-permissions/server/src/index.js";
var srcExports = requireSrc();
export { srcExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(srcExports);